/**
 * Created by i.lovenkov on 25.10.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Bread: {
        displayName: 'Bread'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/CartProduct/Breads/default/Bread/Bread.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Bread = _wrapComponent('Bread')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(Bread, _Component);

    function Bread() {
        (0, _classCallCheck3.default)(this, Bread);
        return (0, _possibleConstructorReturn3.default)(this, (Bread.__proto__ || (0, _getPrototypeOf2.default)(Bread)).apply(this, arguments));
    }

    (0, _createClass3.default)(Bread, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                title = _props.title,
                id = _props.id;

            var toUrl = '/category/' + id + '?limit=' + _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT + '&page=1';

            return _react3.default.createElement(
                'span',
                null,
                _react3.default.createElement(
                    _reactRouter.Link,
                    {
                        to: toUrl,
                        onClick: function onClick(e) {
                            return _this2.props.onClick_Link(id, e);
                        }
                    },
                    title
                )
            );
        }
    }]);
    return Bread;
}(_react2.Component), _class.defaultProps = {
    onClick_Link: function onClick_Link() {}
}, _temp));

exports.default = Bread;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/Breads/default/Bread/Bread.jsx
// module id = 1623
// module chunks = 0